export enum ApprovalActions {
    ApproveTransfer = 'Approve Transfer',
    ApproveLoanPayment = 'Approve Loan Payment',
    ApproveWirePayment = 'Approve WIRE Payment',
    ApproveACHPayment = 'Approve ACH Payment',
}
